import { FC } from 'react'
import type { InvoiceItem } from '@/types/invoice'
import { formatCurrency } from '@/utils/format'

interface InvoiceLineItemsProps {
  items: InvoiceItem[]
  currency: string
}

export const InvoiceLineItems: FC<InvoiceLineItemsProps> = ({
  items,
  currency,
}) => {
  return (
    <div className="py-6 border-t border-[#e5e7eb]">
      {/* Table */}
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#e5e7eb]">
            <th className="text-left text-xs font-semibold text-[#6b7280] uppercase tracking-wider pb-3 pr-4">
              Item
            </th>
            <th className="text-center text-xs font-semibold text-[#6b7280] uppercase tracking-wider pb-3 px-4 w-20">
              Qty
            </th>
            <th className="text-right text-xs font-semibold text-[#6b7280] uppercase tracking-wider pb-3 px-4 w-28">
              Rate
            </th>
            <th className="text-right text-xs font-semibold text-[#6b7280] uppercase tracking-wider pb-3 pl-4 w-28">
              Amount
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#f3f4f6]">
          {items.map((item) => (
            <tr key={item.id} className="group">
              <td className="py-4 pr-4">
                <span className="text-sm text-[#111827] leading-relaxed">
                  {item.description}
                </span>
              </td>
              <td className="py-4 px-4 text-center">
                <span className="text-sm text-[#6b7280] tabular-nums">
                  {item.quantity}
                </span>
              </td>
              <td className="py-4 px-4 text-right">
                <span className="text-sm text-[#6b7280] tabular-nums">
                  {formatCurrency(item.unitPrice, currency)}
                </span>
              </td>
              <td className="py-4 pl-4 text-right">
                <span className="text-sm font-semibold text-[#111827] tabular-nums">
                  {formatCurrency(item.amount, currency)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
